import axios from 'axios'

export  function toLowerCase(list) {
  for (var i = 0; i < list.length; i++) {
    let item = list[i];
    for (let prop in item) {
      if (prop) {
        item[prop.toLowerCase()] = item[prop];
        delete item[prop];
      }

    }
  }
  return list;
}



// WEBPACK FOOTER //
// ./src/transform/httpAjax.js